import Api from '../../api/Api'

const accredible = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    certif: [],
    badge: [],
  },

  //mutations
  mutations: {
    SET_SERTIFIKAT(state, data) {
      state.certif = data
    },
    SET_BADGE(state, data) {
      state.badge = data
    },
    SET_EMPTY(state, empty) {
      state.empty = empty
    },
  },

  //actions
  actions: {
    getCertif({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/workshop/add-webinar/get-desain-sertifikasi`)
          .then((response) => {
            commit('SET_SERTIFIKAT', response.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getBadge({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/workshop/add-webinar/get-desain-badge`)
          .then((response) => {
            commit('SET_BADGE', response.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getCertif(state) {
      return state.certif
    },
    getBadge(state) {
      return state.badge
    },
  },
}

export default accredible
